<app-header [forceLightBackground]="true"></app-header>
<div class="provider-dataset">
  <div class="provider-dataset--layout">
    <app-org-admin-sidebar *ngIf="isOrgAdminRoute" class="provider-dataset--sidebar"></app-org-admin-sidebar>
    <app-provider-sidebar *ngIf="!isOrgAdminRoute" class="provider-dataset--sidebar"></app-provider-sidebar>
    <div class="provider-dataset--content">
      <app-page-header></app-page-header>
      <div class="dataset-container">
        <!-- Step 2 Template -->
        <ng-template #step2Template>
          <form [formGroup]="metadataForm">
            <div class="step-content" [class.step-content--metrics]="!isModel()">
              <ng-container *ngIf="isModel()">
              <h2 class="step-title">Enter Metadata</h2>
              
              <!-- Dataset Information Fields (Disabled) -->
              <div *ngIf="datasetData" class="form-fields">
                <div class="form-row">
                  <!-- Title Field (Disabled) -->
                  <div class="form-field" [class.col-6]="isModel()" [class.col-12]="!isModel()">
                    <label for="dataset-title" class="form-label">
                      Title <span class="required">*</span>
                    </label>
                    <input
                      type="text"
                      id="dataset-title"
                      [value]="datasetData.title"
                      class="form-input"
                      disabled
                    />
                  </div>

                  <!-- Permission Field (Disabled, models only) -->
                  <div *ngIf="isModel()" class="form-field col-6">
                    <label for="dataset-permission" class="form-label">
                      Permission <span class="required">*</span>
                    </label>
                    <input
                      type="text"
                      id="dataset-permission"
                      [value]="getPermissionDisplayLabel(datasetData.permission)"
                      class="form-input"
                      disabled
                    />
                  </div>
                </div>
                
                <!-- HR Line -->
                <hr class="form-divider" />
              </div>

              <!-- For Models: Description Fields, Industry and License -->
              <ng-container *ngIf="isModel()">
                <!-- Description Fields -->
                <div class="form-fields">
                  <div class="form-row">
                    <!-- Short Description - 50% Width -->
                    <div class="form-field col-6">
                      <label for="short-description" class="form-label">
                        Short Description <span class="required">*</span>
                      </label>
                      <div class="textarea-wrapper">
                        <textarea
                          id="short-description"
                          formControlName="shortDescription"
                          class="form-textarea"
                          rows="4"
                          placeholder="Enter a brief description of the model"
                          [maxlength]="getShortDescriptionMaxLength()"
                          [class.error]="metadataForm.get('shortDescription')?.invalid && metadataForm.get('shortDescription')?.touched"
                        ></textarea>
                        <span class="character-count" [class.character-limit-reached]="getShortDescriptionLength() >= getShortDescriptionMaxLength()">
                          {{ getShortDescriptionLength() }}/{{ getShortDescriptionMaxLength() }} Characters
                        </span>
                      </div>
                      <div
                        *ngIf="metadataForm.get('shortDescription')?.invalid && metadataForm.get('shortDescription')?.touched"
                        class="error-message"
                      >
                        <span *ngIf="metadataForm.get('shortDescription')?.errors?.['required']">Short description is required</span>
                        <span *ngIf="metadataForm.get('shortDescription')?.errors?.['minlength']">Short description must be at least 50 characters</span>
                        <span *ngIf="metadataForm.get('shortDescription')?.errors?.['maxlength']">Short description cannot exceed {{ getShortDescriptionMaxLength() }} characters</span>
                      </div>
                    </div>

                    <!-- Long Description - 50% Width -->
                    <div class="form-field col-6">
                      <label for="long-description" class="form-label">
                        Long Description <span class="required">*</span>
                      </label>
                      <div class="textarea-wrapper">
                        <textarea
                          id="long-description"
                          formControlName="longDescription"
                          class="form-textarea"
                          rows="4"
                          placeholder="Enter a detailed description of the model"
                          [maxlength]="getLongDescriptionMaxLength()"
                          [class.error]="metadataForm.get('longDescription')?.invalid && metadataForm.get('longDescription')?.touched"
                        ></textarea>
                        <span class="character-count" [class.character-limit-reached]="getLongDescriptionLength() >= getLongDescriptionMaxLength()">
                          {{ getLongDescriptionLength() }}/{{ getLongDescriptionMaxLength() }} Characters
                        </span>
                      </div>
                      <div
                        *ngIf="metadataForm.get('longDescription')?.invalid && metadataForm.get('longDescription')?.touched"
                        class="error-message"
                      >
                        <span *ngIf="metadataForm.get('longDescription')?.errors?.['required']">Long description is required</span>
                        <span *ngIf="metadataForm.get('longDescription')?.errors?.['minlength']">Long description must be at least 50 characters</span>
                        <span *ngIf="metadataForm.get('longDescription')?.errors?.['maxlength']">Long description cannot exceed {{ getLongDescriptionMaxLength() }} characters</span>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Industry and License Fields -->
                <div class="form-fields">
                  <div class="form-row">
                    <!-- Industry Field -->
                    <div class="form-field col-6">
                      <label for="industry" class="form-label">
                        Industry <span class="required">*</span>
                      </label>
                      <div class="custom-dropdown-wrapper">
                        <div
                          class="custom-dropdown-trigger"
                          [class.error]="metadataForm.get('industry')?.invalid && metadataForm.get('industry')?.touched"
                          [class.open]="isIndustryDropdownOpen"
                          (click)="toggleIndustryDropdown()"
                        >
                          <div class="trigger-content">
                            <span *ngIf="!metadataForm.get('industry')?.value" class="placeholder">Select industry</span>
                            <span *ngIf="metadataForm.get('industry')?.value" class="selected-value">
                              {{ getSelectedIndustryLabel() }}
                            </span>
                            <svg class="dropdown-arrow" [class.open]="isIndustryDropdownOpen" width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M1 1L6 6L11 1" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                          </div>
                        </div>
                        <div class="custom-dropdown-panel" [class.panel-open-upward]="isIndustryDropdownUpward" *ngIf="isIndustryDropdownOpen">
                          <div
                            *ngFor="let option of industryOptions"
                            class="dropdown-option"
                            [class.selected]="isIndustrySelected(option.value)"
                            (click)="selectIndustry(option)"
                          >
                            <div class="checkbox-wrapper">
                              <div class="checkbox-custom" [class.checked]="isIndustrySelected(option.value)"></div>
                            </div>
                            <span class="option-label">{{ option.label }}</span>
                          </div>
                        </div>
                      </div>
                      <div
                        *ngIf="metadataForm.get('industry')?.invalid && metadataForm.get('industry')?.touched"
                        class="error-message"
                      >
                        Industry is required
                      </div>
                    </div>

                    <!-- License Field -->
                    <div class="form-field col-6">
                      <label for="license" class="form-label">
                        License <span class="required">*</span>
                      </label>
                    <div class="custom-dropdown-wrapper">
                      <div
                        class="custom-dropdown-trigger"
                        [class.error]="metadataForm.get('license')?.invalid && metadataForm.get('license')?.touched"
                        [class.open]="isLicenseDropdownOpen"
                        (click)="toggleLicenseDropdown()"
                      >
                        <div class="trigger-content">
                          <span *ngIf="!metadataForm.get('license')?.value" class="placeholder">Select license</span>
                          <span *ngIf="metadataForm.get('license')?.value && metadataForm.get('license')?.value !== 'Other'" class="selected-value">
                            {{ getSelectedLicenseLabel() }}
                          </span>
                          <span *ngIf="metadataForm.get('license')?.value === 'Other'" class="selected-value">
                            Other
                          </span>
                          <svg class="dropdown-arrow" [class.open]="isLicenseDropdownOpen" width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 1L6 6L11 1" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          </svg>
                        </div>
                      </div>
                      <div class="custom-dropdown-panel" [class.panel-open-upward]="isLicenseDropdownUpward" *ngIf="isLicenseDropdownOpen">
                        <div
                          *ngFor="let option of licenseOptions"
                          class="dropdown-option"
                          [class.selected]="isLicenseSelected(option.value)"
                          (click)="selectLicense(option)"
                        >
                          <div class="checkbox-wrapper">
                            <div class="checkbox-custom" [class.checked]="isLicenseSelected(option.value)"></div>
                          </div>
                          <span class="option-label">{{ option.label }}</span>
                        </div>
                      </div>
                    </div>
                    <div
                      *ngIf="metadataForm.get('license')?.invalid && metadataForm.get('license')?.touched"
                      class="error-message"
                    >
                      License is required
                    </div>
                  </div>

                      <!-- Other License Input (shown when "Other" is selected) -->
                      <div 
                        class="form-field col-6" 
                        *ngIf="isOtherLicenseSelected()"
                      >
                        <label for="other-license" class="form-label">
                          Specify License <span class="required">*</span>
                        </label>
                        <input
                          type="text"
                          id="other-license"
                          formControlName="otherLicense"
                          class="form-input"
                          placeholder="Enter license name"
                          [class.error]="metadataForm.get('otherLicense')?.invalid && metadataForm.get('otherLicense')?.touched && isOtherLicenseSelected()"
                        />
                        <div
                          *ngIf="metadataForm.get('otherLicense')?.invalid && metadataForm.get('otherLicense')?.touched && isOtherLicenseSelected()"
                          class="error-message"
                        >
                          Please specify the license name
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </ng-container>

              <!-- For Datasets: Benchmark metric fields -->
              <div *ngIf="!isModel()" class="metadata-layout">
              <aside class="metadata-index" aria-label="Page index">
                <div class="metadata-index__head">
                  <div class="metadata-index__toggle metadata-index__toggle--static">
                    <span class="metadata-index__toggle-icon" aria-hidden="true"></span>
                    <span class="metadata-index__title">Index</span>
                  </div>
                </div>
                <nav>
                  <ul class="metadata-index__list">
                    <li *ngFor="let item of indexItems">
                      <a
                        href="javascript:void(0)"
                        class="metadata-index__link"
                        [class.metadata-index__link--sub]="item.level === 2"
                        [class.metadata-index__link--active]="activeIndexId === item.id"
                        (click)="scrollToIndexItem(item); $event.preventDefault()"
                      >{{ item.label }}</a>
                    </li>
                  </ul>
                </nav>
              </aside>
              <div class="metadata-panel">
                <div class="metadata-panel__header">
                  <div class="metadata-panel__title-group">
                    <h2 class="metadata-panel__title">{{ isBenchmarkPhase() ? 'Additional Metadata' : 'Enter Metadata' }}</h2>
                    <p *ngIf="!isBenchmarkPhase()" class="metadata-panel__subtitle">
                      Describe your dataset in the Croissant metadata format. Fields marked * are required.
                    </p>
                    <p *ngIf="isBenchmarkPhase()" class="metadata-panel__subtitle">
                      Add the benchmark characteristics, input and output details, and metrics for your dataset. Fields marked * are required.
                    </p>
                  </div>
                  <div *ngIf="isBenchmarkPhase()" class="metadata-panel__badge">
                    <span class="metadata-panel__badge-count">{{ getFilledFieldsCount() }}</span>
                    <span class="metadata-panel__badge-label">of {{ getTotalRequiredFieldsCount() }} filled</span>
                  </div>
                </div>

                <div *ngIf="datasetData" class="metadata-dataset-card">
                  <div class="metadata-dataset-card__icon" aria-hidden="true">
                    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M4 7C4 5.89543 4.89543 5 6 5H18C19.1046 5 20 5.89543 20 7V17C20 18.1046 19.1046 19 18 19H6C4.89543 19 4 18.1046 4 17V7Z" stroke="currentColor" stroke-width="1.75"/>
                      <path d="M8 9H16M8 13H13" stroke="currentColor" stroke-width="1.75" stroke-linecap="round"/>
                    </svg>
                  </div>
                  <div class="metadata-dataset-card__body">
                    <span class="metadata-dataset-card__label">Dataset title</span>
                    <span class="metadata-dataset-card__value">{{ datasetData.title }}</span>
                  </div>
                </div>


                <!-- ============ Croissant metadata ============ -->
                <ng-container *ngIf="!isBenchmarkPhase()">
                <datalist id="croissant-data-types">
                  <option *ngFor="let type of croissantDataTypes" [value]="type"></option>
                </datalist>
                <datalist id="croissant-encoding-formats">
                  <option value="text/csv"></option>
                  <option value="application/json"></option>
                  <option value="application/zip"></option>
                  <option value="application/dicom"></option>
                  <option value="application/x-parquet"></option>
                  <option value="image/jpeg"></option>
                  <option value="image/png"></option>
                </datalist>

                <section [class.is-collapsed]="isCollapsed('croissant-core-heading')" class="dataset-details-section" aria-labelledby="croissant-core-heading">
                  <div class="dataset-metrics-section__header">
                    <h3 id="croissant-core-heading" class="dataset-details-section__title"><button type="button" class="collapse-toggle" [attr.aria-expanded]="!isCollapsed('croissant-core-heading')" aria-label="Toggle section" (click)="toggleCollapsed('croissant-core-heading')"></button>Croissant metadata</h3>
                    <p class="dataset-metrics-section__subtitle">
                      The dataset name is your title from Step 1. These properties follow the
                      <a href="https://docs.mlcommons.org/croissant/docs/croissant-spec.html" target="_blank" rel="noopener">Croissant specification</a>.
                    </p>
                  </div>
                  <div class="dataset-details-grid">
                    <div class="dataset-detail-field dataset-detail-field--wide" [class.dataset-detail-field--invalid]="isPathInvalid('croissantDescription')">
                      <label for="croissantDescription" class="dataset-detail-field__label">
                        Description <span class="required">*</span>
                      </label>
                      <textarea
                        id="croissantDescription"
                        formControlName="croissantDescription"
                        class="dataset-detail-field__textarea"
                        rows="4"
                        maxlength="5000"
                        placeholder="What the data is, how it was collected or labelled, and how it may be used."
                        [class.error]="isPathInvalid('croissantDescription')"
                      ></textarea>
                      <div *ngIf="isPathInvalid('croissantDescription')" class="dataset-detail-field__error">Description is required</div>
                    </div>

                    <div class="dataset-detail-field">
                      <label for="croissantLicense" class="dataset-detail-field__label">License</label>
                      <input id="croissantLicense" type="text" formControlName="croissantLicense" class="dataset-detail-field__input" placeholder="e.g. https://creativecommons.org/licenses/by/4.0/" />
                    </div>
                    <div class="dataset-detail-field">
                      <label for="croissantVersion" class="dataset-detail-field__label">Version</label>
                      <input id="croissantVersion" type="text" formControlName="croissantVersion" class="dataset-detail-field__input" placeholder="1.0.0" />
                    </div>
                    <div class="dataset-detail-field">
                      <label for="croissantDatePublished" class="dataset-detail-field__label">Date published</label>
                      <input id="croissantDatePublished" type="date" formControlName="croissantDatePublished" class="dataset-detail-field__input" [class.error]="isPathInvalid('croissantDatePublished')" />
                    </div>
                    <div class="dataset-detail-field" [class.dataset-detail-field--invalid]="isPathInvalid('croissantUrl')">
                      <label for="croissantUrl" class="dataset-detail-field__label">URL</label>
                      <input id="croissantUrl" type="text" formControlName="croissantUrl" class="dataset-detail-field__input" placeholder="https://example.org/my-dataset" [class.error]="isPathInvalid('croissantUrl')" />
                      <div *ngIf="isPathInvalid('croissantUrl')" class="dataset-detail-field__error">Enter a full http(s) URL</div>
                    </div>
                    <div class="dataset-detail-field">
                      <label for="croissantCreator" class="dataset-detail-field__label">Creator</label>
                      <input id="croissantCreator" type="text" formControlName="croissantCreator" class="dataset-detail-field__input" placeholder="Organisation or authors, comma separated" />
                    </div>
                    <div class="dataset-detail-field">
                      <label for="croissantKeywords" class="dataset-detail-field__label">Keywords</label>
                      <input id="croissantKeywords" type="text" formControlName="croissantKeywords" class="dataset-detail-field__input" placeholder="e.g. health, imaging, oncology" />
                    </div>
                    <div class="dataset-detail-field dataset-detail-field--wide">
                      <label for="croissantCiteAs" class="dataset-detail-field__label">Citation</label>
                      <textarea id="croissantCiteAs" formControlName="croissantCiteAs" class="dataset-detail-field__textarea" rows="2" maxlength="1000" placeholder="How to cite this dataset"></textarea>
                    </div>
                  </div>
                </section>

                <section [class.is-collapsed]="isCollapsed('croissant-distribution-heading')" class="dataset-details-section dataset-plots-section" aria-labelledby="croissant-distribution-heading">
                  <div class="dataset-plots-section__header">
                    <div>
                      <h3 id="croissant-distribution-heading" class="dataset-details-section__title"><button type="button" class="collapse-toggle" [attr.aria-expanded]="!isCollapsed('croissant-distribution-heading')" aria-label="Toggle section" (click)="toggleCollapsed('croissant-distribution-heading')"></button>Files (distribution)</h3>
                      <p class="dataset-plots-section__subtitle">
                        The files or file groups that make up the dataset. Use a file for a single file (name it as it will be uploaded, or give its URL) and a file set for a folder pattern such as <em>images/*.jpg</em>.
                      </p>
                    </div>
                    <button type="button" class="dataset-plots-section__add-btn" (click)="addDistribution()">Add file</button>
                  </div>

                  <div formArrayName="croissantDistributions" class="dataset-plots-section__list">
                    <article
                      *ngFor="let entry of croissantDistributions.controls; let i = index"
                      [id]="'card-dist-' + i" class="dataset-plot-card"
                      [class.is-collapsed]="isCollapsed('dist-' + i)"
                      [formGroupName]="i"
                    >
                      <div class="dataset-plot-card__header">
                        <h4 class="dataset-plot-card__title"><button type="button" class="collapse-toggle" [attr.aria-expanded]="!isCollapsed('dist-' + i)" aria-label="Toggle card" (click)="toggleCollapsed('dist-' + i)"></button>File {{ i + 1 }}</h4>
                        <button type="button" class="dataset-plot-card__remove" [disabled]="croissantDistributions.length <= 1" (click)="removeDistribution(i)">Remove</button>
                      </div>
                      <div class="dataset-details-grid">
                        <div class="dataset-detail-field">
                          <label class="dataset-detail-field__label" [for]="'dist-kind-' + i">Type <span class="required">*</span></label>
                          <select [id]="'dist-kind-' + i" formControlName="kind" class="dataset-detail-field__input">
                            <option value="FileObject">Single file</option>
                            <option value="FileSet">File set (pattern)</option>
                          </select>
                        </div>
                        <div class="dataset-detail-field" [class.dataset-detail-field--invalid]="isPathInvalid('croissantDistributions', i, 'name')">
                          <label class="dataset-detail-field__label" [for]="'dist-name-' + i">Name <span class="required">*</span></label>
                          <input [id]="'dist-name-' + i" type="text" formControlName="name" class="dataset-detail-field__input" placeholder="e.g. labels.csv" [class.error]="isPathInvalid('croissantDistributions', i, 'name')" />
                          <div *ngIf="isPathInvalid('croissantDistributions', i, 'name')" class="dataset-detail-field__error">Name is required</div>
                        </div>
                        <div class="dataset-detail-field" [class.dataset-detail-field--invalid]="isPathInvalid('croissantDistributions', i, 'encodingFormat')">
                          <label class="dataset-detail-field__label" [for]="'dist-encoding-' + i">Encoding format <span class="required">*</span></label>
                          <input [id]="'dist-encoding-' + i" type="text" list="croissant-encoding-formats" formControlName="encodingFormat" class="dataset-detail-field__input" placeholder="e.g. text/csv" [class.error]="isPathInvalid('croissantDistributions', i, 'encodingFormat')" />
                          <div *ngIf="isPathInvalid('croissantDistributions', i, 'encodingFormat')" class="dataset-detail-field__error">Encoding format is required</div>
                        </div>
                        <div *ngIf="!isDistributionFileSet(i)" class="dataset-detail-field dataset-detail-field--wide">
                          <label class="dataset-detail-field__label" [for]="'dist-url-' + i">Content URL or file path <span class="required">*</span></label>
                          <input [id]="'dist-url-' + i" type="text" formControlName="contentUrl" class="dataset-detail-field__input" placeholder="labels.csv or https://…/labels.csv" />
                        </div>
                        <div *ngIf="isDistributionFileSet(i)" class="dataset-detail-field dataset-detail-field--wide">
                          <label class="dataset-detail-field__label" [for]="'dist-includes-' + i">Includes (pattern) <span class="required">*</span></label>
                          <input [id]="'dist-includes-' + i" type="text" formControlName="includes" class="dataset-detail-field__input" placeholder="images/*/*.jpg" />
                        </div>
                        <div *ngIf="!isDistributionFileSet(i)" class="dataset-detail-field dataset-detail-field--wide">
                          <label class="dataset-detail-field__label" [for]="'dist-sha-' + i">SHA-256 checksum</label>
                          <input [id]="'dist-sha-' + i" type="text" formControlName="sha256" class="dataset-detail-field__input" placeholder="Optional — lets consumers verify the file" />
                        </div>
                        <div class="dataset-detail-field dataset-detail-field--wide">
                          <label class="dataset-detail-field__label" [for]="'dist-desc-' + i">Description</label>
                          <input [id]="'dist-desc-' + i" type="text" formControlName="description" class="dataset-detail-field__input" placeholder="What these files are" />
                        </div>
                      </div>
                    </article>
                  </div>
                </section>

                <section [class.is-collapsed]="isCollapsed('croissant-recordset-heading')" class="dataset-details-section dataset-plots-section" aria-labelledby="croissant-recordset-heading">
                  <div class="dataset-plots-section__header">
                    <div>
                      <h3 id="croissant-recordset-heading" class="dataset-details-section__title"><button type="button" class="collapse-toggle" [attr.aria-expanded]="!isCollapsed('croissant-recordset-heading')" aria-label="Toggle section" (click)="toggleCollapsed('croissant-recordset-heading')"></button>Records and fields (record sets)</h3>
                      <p class="dataset-plots-section__subtitle">
                        Describe the structure of the data: each record set is a table of records made of typed fields. Optionally link a field to the file (and column) its values come from.
                      </p>
                    </div>
                    <button type="button" class="dataset-plots-section__add-btn" (click)="addRecordSet()">Add record set</button>
                  </div>

                  <div formArrayName="croissantRecordSets" class="dataset-plots-section__list">
                    <article
                      *ngFor="let recordSet of croissantRecordSets.controls; let rs = index"
                      [id]="'card-rs-' + rs" class="dataset-plot-card"
                      [class.is-collapsed]="isCollapsed('rs-' + rs)"
                      [formGroupName]="rs"
                    >
                      <div class="dataset-plot-card__header">
                        <h4 class="dataset-plot-card__title"><button type="button" class="collapse-toggle" [attr.aria-expanded]="!isCollapsed('rs-' + rs)" aria-label="Toggle card" (click)="toggleCollapsed('rs-' + rs)"></button>Record set {{ rs + 1 }}</h4>
                        <button type="button" class="dataset-plot-card__remove" [disabled]="croissantRecordSets.length <= 1" (click)="removeRecordSet(rs)">Remove</button>
                      </div>
                      <div class="dataset-details-grid">
                        <div class="dataset-detail-field" [class.dataset-detail-field--invalid]="isPathInvalid('croissantRecordSets', rs, 'name')">
                          <label class="dataset-detail-field__label" [for]="'rs-name-' + rs">Name <span class="required">*</span></label>
                          <input [id]="'rs-name-' + rs" type="text" formControlName="name" class="dataset-detail-field__input" placeholder="e.g. records" [class.error]="isPathInvalid('croissantRecordSets', rs, 'name')" />
                          <div *ngIf="isPathInvalid('croissantRecordSets', rs, 'name')" class="dataset-detail-field__error">Name is required</div>
                        </div>
                        <div class="dataset-detail-field dataset-detail-field--wide">
                          <label class="dataset-detail-field__label" [for]="'rs-desc-' + rs">Description</label>
                          <input [id]="'rs-desc-' + rs" type="text" formControlName="description" class="dataset-detail-field__input" placeholder="e.g. One record per case" />
                        </div>
                      </div>

                      <div class="dataset-plot-card__categories">
                        <div class="dataset-plot-card__categories-head">
                          <span class="dataset-plot-card__categories-title">Fields</span>
                          <button type="button" class="dataset-plot-card__add-category" (click)="addRecordSetField(rs)">Add field</button>
                        </div>
                        <div formArrayName="fields" class="dataset-plot-card__categories-list">
                          <div
                            *ngFor="let field of getRecordSetFields(rs).controls; let f = index"
                            class="dataset-plot-category"
                            [formGroupName]="f"
                          >
                            <div class="dataset-plot-category__fields">
                              <div class="dataset-detail-field" [class.dataset-detail-field--invalid]="isPathInvalid('croissantRecordSets', rs, 'fields', f, 'name')">
                                <label class="dataset-detail-field__label">Field name <span class="required">*</span></label>
                                <input type="text" formControlName="name" class="dataset-detail-field__input" placeholder="e.g. case_id" [class.error]="isPathInvalid('croissantRecordSets', rs, 'fields', f, 'name')" />
                              </div>
                              <div class="dataset-detail-field" [class.dataset-detail-field--invalid]="isPathInvalid('croissantRecordSets', rs, 'fields', f, 'dataType')">
                                <label class="dataset-detail-field__label">Data type <span class="required">*</span></label>
                                <input type="text" list="croissant-data-types" formControlName="dataType" class="dataset-detail-field__input" placeholder="sc:Text" [class.error]="isPathInvalid('croissantRecordSets', rs, 'fields', f, 'dataType')" />
                              </div>
                              <div class="dataset-detail-field">
                                <label class="dataset-detail-field__label">Source file</label>
                                <select formControlName="sourceDistribution" class="dataset-detail-field__input">
                                  <option value="">None</option>
                                  <option *ngFor="let name of croissantDistributionNames" [value]="name">{{ name }}</option>
                                </select>
                              </div>
                              <div class="dataset-detail-field">
                                <label class="dataset-detail-field__label">Source column</label>
                                <input type="text" formControlName="sourceColumn" class="dataset-detail-field__input" placeholder="Column in the source file" />
                              </div>
                              <div class="dataset-detail-field dataset-detail-field--wide">
                                <label class="dataset-detail-field__label">Description</label>
                                <input type="text" formControlName="description" class="dataset-detail-field__input" placeholder="Optional" />
                              </div>
                            </div>
                            <button type="button" class="dataset-plot-category__remove" [disabled]="getRecordSetFields(rs).length <= 1" (click)="removeRecordSetField(rs, f)">Remove</button>
                          </div>
                        </div>
                      </div>
                    </article>
                  </div>
                </section>

                <section
                  *ngIf="showCroissantIssues || metadataForm.dirty"
                  class="croissant-issues"
                  [class.croissant-issues--valid]="croissantIssues.errors.length === 0"
                  aria-live="polite"
                >
                  <h3 class="croissant-issues__title">
                    <ng-container *ngIf="croissantIssues.errors.length === 0">Croissant metadata is valid</ng-container>
                    <ng-container *ngIf="croissantIssues.errors.length > 0">
                      {{ croissantIssues.errors.length }} Croissant issue{{ croissantIssues.errors.length === 1 ? '' : 's' }} to fix
                    </ng-container>
                  </h3>
                  <ul *ngIf="croissantIssues.errors.length > 0" class="croissant-issues__list">
                    <li *ngFor="let issue of croissantIssues.errors">{{ issue }}</li>
                  </ul>
                  <ng-container *ngIf="croissantIssues.warnings.length > 0">
                    <p class="croissant-issues__warn-title">Suggestions</p>
                    <ul class="croissant-issues__list croissant-issues__list--warn">
                      <li *ngFor="let issue of croissantIssues.warnings">{{ issue }}</li>
                    </ul>
                  </ng-container>
                </section>

                </ng-container>

                <!-- ============ Benchmark details (TANUH) ============ -->
                <ng-container *ngIf="isBenchmarkPhase()">
                <section [class.is-collapsed]="isCollapsed('dataset-details-heading')" class="dataset-details-section" aria-labelledby="dataset-details-heading">
                  <h3 id="dataset-details-heading" class="dataset-details-section__title"><button type="button" class="collapse-toggle" [attr.aria-expanded]="!isCollapsed('dataset-details-heading')" aria-label="Toggle section" (click)="toggleCollapsed('dataset-details-heading')"></button>Dataset characteristics</h3>
                  <div class="dataset-details-grid">
                    <div
                      *ngFor="let field of datasetDetailFields"
                      class="dataset-detail-field"
                      [class.dataset-detail-field--filled]="isDetailFieldFilled(field.key)"
                      [class.dataset-detail-field--invalid]="isDetailFieldInvalid(field.key)"
                    >
                      <label [for]="field.key" class="dataset-detail-field__label">
                        {{ field.label }} <span class="required">*</span>
                      </label>
                      <input
                        type="text"
                        [id]="field.key"
                        [formControlName]="field.key"
                        class="dataset-detail-field__input"
                        [placeholder]="field.placeholder"
                        [class.error]="isDetailFieldInvalid(field.key)"
                      />
                      <div
                        *ngIf="isDetailFieldInvalid(field.key)"
                        class="dataset-detail-field__error"
                      >
                        {{ getDetailFieldError(field.key) }}
                      </div>
                    </div>
                  </div>
                </section>

                <section [class.is-collapsed]="isCollapsed('dataset-input-heading')" class="dataset-details-section" aria-labelledby="dataset-input-heading">
                  <h3 id="dataset-input-heading" class="dataset-details-section__title"><button type="button" class="collapse-toggle" [attr.aria-expanded]="!isCollapsed('dataset-input-heading')" aria-label="Toggle section" (click)="toggleCollapsed('dataset-input-heading')"></button>Input</h3>
                  <div class="dataset-details-grid">
                    <div
                      *ngFor="let field of datasetInputFields"
                      class="dataset-detail-field"
                      [class.dataset-detail-field--filled]="isDetailFieldFilled(field.key)"
                      [class.dataset-detail-field--invalid]="isDetailFieldInvalid(field.key)"
                      [class.dataset-detail-field--wide]="field.type === 'textarea'"
                    >
                      <label [for]="field.key" class="dataset-detail-field__label">
                        {{ field.label }}
                        <span *ngIf="isFieldRequired(field)" class="required">*</span>
                      </label>
                      <textarea
                        *ngIf="field.type === 'textarea'; else inputFieldControl"
                        [id]="field.key"
                        [formControlName]="field.key"
                        class="dataset-detail-field__textarea"
                        rows="3"
                        [placeholder]="field.placeholder"
                        [maxlength]="field.maxLength ?? 1000"
                        [class.error]="isDetailFieldInvalid(field.key)"
                      ></textarea>
                      <ng-template #inputFieldControl>
                        <input
                          type="text"
                          [id]="field.key"
                          [formControlName]="field.key"
                          class="dataset-detail-field__input"
                          [placeholder]="field.placeholder"
                          [class.error]="isDetailFieldInvalid(field.key)"
                        />
                      </ng-template>
                      <div
                        *ngIf="isDetailFieldInvalid(field.key)"
                        class="dataset-detail-field__error"
                      >
                        {{ getDetailFieldError(field.key) }}
                      </div>
                    </div>
                  </div>
                </section>

                <section [class.is-collapsed]="isCollapsed('dataset-output-heading')" class="dataset-details-section" aria-labelledby="dataset-output-heading">
                  <h3 id="dataset-output-heading" class="dataset-details-section__title"><button type="button" class="collapse-toggle" [attr.aria-expanded]="!isCollapsed('dataset-output-heading')" aria-label="Toggle section" (click)="toggleCollapsed('dataset-output-heading')"></button>Output</h3>
                  <div class="dataset-details-grid">
                    <div
                      *ngFor="let field of datasetOutputFields"
                      class="dataset-detail-field"
                      [class.dataset-detail-field--filled]="isDetailFieldFilled(field.key)"
                      [class.dataset-detail-field--invalid]="isDetailFieldInvalid(field.key)"
                      [class.dataset-detail-field--wide]="field.type === 'textarea'"
                    >
                      <label [for]="field.key" class="dataset-detail-field__label">
                        {{ field.label }}
                        <span *ngIf="isFieldRequired(field)" class="required">*</span>
                      </label>
                      <textarea
                        *ngIf="field.type === 'textarea'; else outputFieldControl"
                        [id]="field.key"
                        [formControlName]="field.key"
                        class="dataset-detail-field__textarea"
                        rows="3"
                        [placeholder]="field.placeholder"
                        [maxlength]="field.maxLength ?? 2000"
                        [class.error]="isDetailFieldInvalid(field.key)"
                      ></textarea>
                      <ng-template #outputFieldControl>
                        <input
                          type="text"
                          [id]="field.key"
                          [formControlName]="field.key"
                          class="dataset-detail-field__input"
                          [placeholder]="field.placeholder"
                          [class.error]="isDetailFieldInvalid(field.key)"
                        />
                      </ng-template>
                      <div
                        *ngIf="isDetailFieldInvalid(field.key)"
                        class="dataset-detail-field__error"
                      >
                        {{ getDetailFieldError(field.key) }}
                      </div>
                    </div>
                  </div>
                </section>

                <section [class.is-collapsed]="isCollapsed('dataset-metrics-heading')" class="dataset-metrics-section" aria-labelledby="dataset-metrics-heading">
                  <div class="dataset-metrics-section__header">
                    <h3 id="dataset-metrics-heading" class="dataset-metrics-section__title"><button type="button" class="collapse-toggle" [attr.aria-expanded]="!isCollapsed('dataset-metrics-heading')" aria-label="Toggle section" (click)="toggleCollapsed('dataset-metrics-heading')"></button>Benchmark metrics</h3>
                    <p class="dataset-metrics-section__subtitle">
                      Choose the metrics your benchmark reports<ng-container *ngIf="problemStatementLabel"> — the list is limited to what the {{ problemStatementLabel }} evaluator produces</ng-container>. Values are captured later, when a model is evaluated.
                    </p>
                  </div>
                <div class="metrics-grid" formArrayName="customMetrics">
                  <div
                    *ngFor="let metric of customMetrics.controls; let i = index"
                    [formGroupName]="i"
                    class="metric-field-card"
                    [class.metric-field-card--filled]="isCustomMetricFilled(i)"
                    [class.metric-field-card--invalid]="isCustomMetricInvalid(i)"
                  >
                    <label [id]="'custom-metric-label-' + i" class="metric-field-card__label">
                      <span class="metric-field-card__index">{{ i + 1 }}</span>
                      <span class="metric-field-card__text">Metric name</span>
                      <span class="required">*</span>
                    </label>
                    <div class="metric-field-card__input-wrap custom-dropdown-wrapper">
                      <div
                        [id]="'custom-metric-' + i"
                        class="custom-dropdown-trigger"
                        role="combobox"
                        tabindex="0"
                        aria-haspopup="listbox"
                        [attr.aria-labelledby]="'custom-metric-label-' + i"
                        [attr.aria-expanded]="openCustomMetricDropdownIndex === i"
                        [class.error]="isCustomMetricInvalid(i)"
                        [class.open]="openCustomMetricDropdownIndex === i"
                        (click)="toggleCustomMetricDropdown(i)"
                        (keydown.enter)="toggleCustomMetricDropdown(i)"
                        (keydown.space)="toggleCustomMetricDropdown(i); $event.preventDefault()"
                      >
                        <div class="trigger-content">
                          <span *ngIf="!isCustomMetricFilled(i)" class="placeholder">Select metric</span>
                          <span *ngIf="isCustomMetricFilled(i)" class="selected-value">{{ metric.get('name')?.value }}</span>
                          <svg class="dropdown-arrow" [class.open]="openCustomMetricDropdownIndex === i" width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 1L6 6L11 1" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          </svg>
                        </div>
                      </div>
                      <div class="custom-dropdown-panel" role="listbox" *ngIf="openCustomMetricDropdownIndex === i">
                        <div
                          *ngFor="let opt of evaluatorMetricOptions"
                          class="dropdown-option"
                          role="option"
                          [class.selected]="isCustomMetricOptionSelected(i, opt)"
                          [class.dropdown-option--disabled]="isCustomMetricOptionTaken(i, opt)"
                          [attr.aria-selected]="isCustomMetricOptionSelected(i, opt)"
                          [attr.aria-disabled]="isCustomMetricOptionTaken(i, opt)"
                          (click)="selectCustomMetric(i, opt)"
                        >
                          <div class="checkbox-wrapper">
                            <div class="checkbox-custom" [class.checked]="isCustomMetricOptionSelected(i, opt)"></div>
                          </div>
                          <span class="option-label">{{ opt.label }}</span>
                        </div>
                        <div *ngIf="evaluatorMetricOptions.length === 0" class="dropdown-panel-empty">
                          Select a problem statement on the setup step first.
                        </div>
                      </div>
                    </div>
                    <div class="metric-field-card__range">
                      <div class="metric-field-card__range-field">
                        <label [for]="'custom-metric-min-' + i" class="metric-field-card__range-label">Min</label>
                        <input
                          type="text"
                          inputmode="decimal"
                          [id]="'custom-metric-min-' + i"
                          formControlName="min"
                          class="metric-field-card__range-input"
                          placeholder="0"
                          [class.error]="isCustomMetricRangeInvalid(i)"
                        />
                      </div>
                      <span class="metric-field-card__range-sep">–</span>
                      <div class="metric-field-card__range-field">
                        <label [for]="'custom-metric-max-' + i" class="metric-field-card__range-label">Max</label>
                        <input
                          type="text"
                          inputmode="decimal"
                          [id]="'custom-metric-max-' + i"
                          formControlName="max"
                          class="metric-field-card__range-input"
                          placeholder="1"
                          [class.error]="isCustomMetricRangeInvalid(i)"
                        />
                      </div>
                    </div>
                    <button
                      *ngIf="customMetrics.length > 1"
                      type="button"
                      class="metric-field-card__remove"
                      (click)="removeCustomMetric(i)"
                    >
                      Remove
                    </button>
                    <div
                      *ngIf="isCustomMetricInvalid(i)"
                      class="metric-field-card__error"
                    >
                      {{ getCustomMetricError(i) }}
                    </div>
                    <div
                      *ngIf="isCustomMetricRangeInvalid(i)"
                      class="metric-field-card__error"
                    >
                      {{ getCustomMetricRangeError(i) }}
                    </div>
                  </div>
                </div>
                <button
                  type="button"
                  class="dataset-metrics-section__add-btn"
                  (click)="addCustomMetric()"
                >
                  Add metric
                </button>
                </section>

                <section [class.is-collapsed]="isCollapsed('dataset-metric-selection-heading')" class="dataset-details-section" aria-labelledby="dataset-metric-selection-heading">
                  <h3 id="dataset-metric-selection-heading" class="dataset-details-section__title"><button type="button" class="collapse-toggle" [attr.aria-expanded]="!isCollapsed('dataset-metric-selection-heading')" aria-label="Toggle section" (click)="toggleCollapsed('dataset-metric-selection-heading')"></button>Primary &amp; secondary metrics</h3>
                  <div class="dataset-details-grid">
                    <div
                      *ngFor="let field of datasetMetricSelectionFields"
                      class="dataset-detail-field"
                      [class.dataset-detail-field--filled]="isDetailFieldFilled(field.key)"
                      [class.dataset-detail-field--invalid]="isDetailFieldInvalid(field.key)"
                    >
                      <label [for]="field.key" class="dataset-detail-field__label">
                        {{ field.label }} <span class="required">*</span>
                      </label>
                      <div class="custom-dropdown-wrapper">
                        <div
                          class="custom-dropdown-trigger"
                          [class.error]="isDetailFieldInvalid(field.key)"
                          [class.open]="isMetricDetailDropdownOpen(field.key)"
                          (click)="toggleMetricDetailDropdown(field.key)"
                        >
                          <div class="trigger-content">
                            <span *ngIf="!metadataForm.get(field.key)?.value" class="placeholder">{{ field.placeholder }}</span>
                            <span *ngIf="metadataForm.get(field.key)?.value" class="selected-value">{{ getMetricDetailLabel(field.key) }}</span>
                            <svg class="dropdown-arrow" [class.open]="isMetricDetailDropdownOpen(field.key)" width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M1 1L6 6L11 1" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                          </div>
                        </div>
                        <div class="custom-dropdown-panel" *ngIf="isMetricDetailDropdownOpen(field.key)">
                          <div
                            *ngFor="let opt of metricDropdownOptions"
                            class="dropdown-option"
                            [class.selected]="isMetricDetailSelected(field.key, opt.key)"
                            (click)="selectMetricDetail(field.key, opt.key)"
                          >
                            <div class="checkbox-wrapper">
                              <div class="checkbox-custom" [class.checked]="isMetricDetailSelected(field.key, opt.key)"></div>
                            </div>
                            <span class="option-label">{{ opt.label }}</span>
                          </div>
                          <div *ngIf="metricDropdownOptions.length === 0" class="dropdown-panel-empty">
                            Name a benchmark metric above first.
                          </div>
                        </div>
                      </div>
                      <div
                        *ngIf="isDetailFieldInvalid(field.key)"
                        class="dataset-detail-field__error"
                      >
                        {{ getDetailFieldError(field.key) }}
                      </div>
                    </div>
                  </div>
                </section>

                <section [class.is-collapsed]="isCollapsed('dataset-plots-heading')"
                  class="dataset-details-section dataset-plots-section"
                  aria-labelledby="dataset-plots-heading"
                >
                  <div class="dataset-plots-section__header">
                    <div>
                      <h3 id="dataset-plots-heading" class="dataset-details-section__title"><button type="button" class="collapse-toggle" [attr.aria-expanded]="!isCollapsed('dataset-plots-heading')" aria-label="Toggle section" (click)="toggleCollapsed('dataset-plots-heading')"></button>
                        Dataset statistics plots
                        <span class="dataset-plots-section__optional">Optional</span>
                      </h3>
                      <p class="dataset-plots-section__subtitle">
                        Configure bar charts shown on the dataset details page, matching the benchmarking dataset statistics layout.
                      </p>
                    </div>
                    <button
                      type="button"
                      class="dataset-plots-section__add-btn"
                      (click)="addDistributionPlot()"
                    >
                      Add plot
                    </button>
                  </div>

                  <p *ngIf="!hasDistributionPlots" class="dataset-plots-section__empty">
                    No plots added yet. Use “Add plot” to define one or more distribution charts.
                  </p>

                  <div formArrayName="distributionPlots" class="dataset-plots-section__list">
                    <article
                      *ngFor="let plot of distributionPlots.controls; let plotIndex = index"
                      [id]="'card-plot-' + plotIndex" class="dataset-plot-card"
                      [class.is-collapsed]="isCollapsed('plot-' + plotIndex)"
                      [formGroupName]="plotIndex"
                    >
                      <div class="dataset-plot-card__header">
                        <h4 class="dataset-plot-card__title"><button type="button" class="collapse-toggle" [attr.aria-expanded]="!isCollapsed('plot-' + plotIndex)" aria-label="Toggle card" (click)="toggleCollapsed('plot-' + plotIndex)"></button>Plot {{ plotIndex + 1 }}</h4>
                        <button
                          type="button"
                          class="dataset-plot-card__remove"
                          (click)="removeDistributionPlot(plotIndex)"
                        >
                          Remove plot
                        </button>
                      </div>

                      <div class="dataset-details-grid">
                        <div class="dataset-detail-field">
                          <label class="dataset-detail-field__label" [for]="'plot-label-' + plotIndex">
                            Plot label
                          </label>
                          <input
                            [id]="'plot-label-' + plotIndex"
                            type="text"
                            formControlName="label"
                            class="dataset-detail-field__input"
                            placeholder="e.g. Label, Sex, Study setting"
                          />
                        </div>
                        <div class="dataset-detail-field">
                          <label class="dataset-detail-field__label" [for]="'plot-total-' + plotIndex">
                            Total
                          </label>
                          <input
                            [id]="'plot-total-' + plotIndex"
                            type="text"
                            formControlName="total"
                            class="dataset-detail-field__input"
                            placeholder="Optional total count"
                          />
                        </div>
                        <div class="dataset-detail-field dataset-detail-field--wide">
                          <label class="dataset-detail-field__label" [for]="'plot-note-' + plotIndex">
                            Note
                          </label>
                          <textarea
                            [id]="'plot-note-' + plotIndex"
                            formControlName="note"
                            class="dataset-detail-field__textarea"
                            rows="2"
                            placeholder="Optional note shown below the chart"
                          ></textarea>
                        </div>
                      </div>

                      <div class="dataset-plot-card__categories">
                        <div class="dataset-plot-card__categories-head">
                          <span class="dataset-plot-card__categories-title">Categories</span>
                          <button
                            type="button"
                            class="dataset-plot-card__add-category"
                            (click)="addPlotCategory(plotIndex)"
                          >
                            Add category
                          </button>
                        </div>

                        <div formArrayName="categories" class="dataset-plot-card__categories-list">
                          <div
                            *ngFor="let category of getPlotCategories(plotIndex).controls; let categoryIndex = index"
                            class="dataset-plot-category"
                            [formGroupName]="categoryIndex"
                          >
                            <div class="dataset-plot-category__fields">
                              <div class="dataset-detail-field">
                                <label class="dataset-detail-field__label">Name</label>
                                <input
                                  type="text"
                                  formControlName="name"
                                  class="dataset-detail-field__input"
                                  placeholder="e.g. Suspicious"
                                />
                              </div>
                              <div class="dataset-detail-field">
                                <label class="dataset-detail-field__label">Count</label>
                                <input
                                  type="number"
                                  formControlName="count"
                                  class="dataset-detail-field__input"
                                  min="0"
                                  step="1"
                                  placeholder="0"
                                />
                              </div>
                              <div class="dataset-detail-field dataset-detail-field--wide">
                                <label class="dataset-detail-field__label">Description</label>
                                <input
                                  type="text"
                                  formControlName="description"
                                  class="dataset-detail-field__input"
                                  placeholder="Optional tooltip description"
                                />
                              </div>
                            </div>
                            <button
                              type="button"
                              class="dataset-plot-category__remove"
                              [disabled]="getPlotCategories(plotIndex).length <= 1"
                              (click)="removePlotCategory(plotIndex, categoryIndex)"
                            >
                              Remove
                            </button>
                          </div>
                        </div>
                      </div>
                    </article>
                  </div>
                </section>
                </ng-container>
              </div>
              </div>
            </div>
          </form>

          <app-modal
            [(visible)]="isPreviewOpen"
            [header]="previewMode === 'confirm' ? 'Review before uploading files' : 'JSON preview'"
            [width]="'860px'"
            [showConfirmButton]="previewMode === 'confirm'"
            [confirmLabel]="'Confirm & continue'"
            [cancelLabel]="previewMode === 'confirm' ? 'Keep editing' : 'Close'"
            (onConfirm)="confirmPreview()"
          >
            <div class="json-preview">
              <div class="json-preview__bar">
                <div class="json-preview__tabs" role="tablist">
                  <button type="button" role="tab" class="json-preview__tab" [class.json-preview__tab--active]="previewTab === 'croissant'" (click)="previewTab = 'croissant'">Croissant metadata</button>
                  <button type="button" role="tab" class="json-preview__tab" [class.json-preview__tab--active]="previewTab === 'benchmark'" (click)="previewTab = 'benchmark'">Benchmark details</button>
                </div>
                <button type="button" class="json-preview__copy" (click)="copyPreview()">Copy</button>
              </div>
              <p *ngIf="previewMode === 'confirm'" class="json-preview__hint">
                This is what will be saved for your dataset. Confirm to create it and move on to uploading files.
              </p>
              <pre class="json-preview__code">{{ previewText }}</pre>
            </div>
          </app-modal>
        </ng-template>

        <!-- Preview JSON action, shown between Previous and Next in the bottom bar -->
        <ng-template #previewAction>
          <button type="button" class="metadata-preview-btn" (click)="openPreview('view')">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <path d="M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7S2 12 2 12Z" stroke="currentColor" stroke-width="1.75" stroke-linejoin="round"/>
              <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="1.75"/>
            </svg>
            Preview
          </button>
        </ng-template>

        <!-- Stepper Component -->
        <app-stepper
          [steps]="stepperStepsWithLabel"
          [currentStep]="currentStep"
          [asyncNext]="true"
          [floatingNavigation]="!isModel()"
          [actionsTemplate]="isModel() ? undefined : previewAction"
          [disableNextButton]="!isMetadataFormValid() || isCreatingItem"
          (stepChange)="onStepChange($event)"
          (next)="onNext()"
          (previous)="onPrevious()"
        ></app-stepper>
      </div>
    </div>
  </div>
</div>

